goog.provide("shadow.js.shim.module$dayjs");
goog.provide("module$shadow_js_shim_module$dayjs");
shadow.js.shim.module$dayjs = shadow.js.nativeProvides["dayjs"] = require("dayjs");
module$shadow_js_shim_module$dayjs.default = shadow.js.shim.module$dayjs;
